export default __webpack_public_path__ + "2fa1b9127e0b168ffc49cea8522692d1.png";